import { lightPalette } from "../palette";

export const MuiTab = {
  MuiTabs: {},
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: "none",
        backgroundColor: lightPalette.background.default,
      },
    },
  },
};
